export enum APINotificationDismissalReason {
  CLEARED = "Cleared",
  TERMINATED = "Terminated",
  INACTIVE = "Inactive merchant",
  TERMNOTICE = "Termination notice sent",
  WARNNOTICE = "Warning notice sent",
}
